import { Box, Typography, Divider } from '@mui/material';

const SYNERGY_LOGO = 'https://synergyecp.com/wp-content/uploads/2024/07/Synergy-ECP-Logo-with-tag-line-rebuild-Sep2021-simple-colors-text-converted-to-shapes-copy.svg';

export default function Footer() {
  return (
    <Box component="footer" sx={{ mt: 8 }}>
      <Divider />
      <Box
        sx={{
          py: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1.5,
        }}
      >
        <img
          src={SYNERGY_LOGO}
          alt="Synergy ECP"
          style={{ height: 40, objectFit: 'contain' }}
        />
        <Typography variant="caption" color="text.secondary">
          © {new Date().getFullYear()} Synergy ECP. Internal use only.
        </Typography>
      </Box>
    </Box>
  );
}
